import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1, 1),
  },
  aqlLevel: {
    minWidth: 120,
  },
}));
